// extracted by mini-css-extract-plugin
module.exports = {"social":"SocialLinks_social__ihyRJ","social_icon":"SocialLinks_social_icon__iHndV"};